<template>
  <div class="page-container">
    <div class="home-page">
      <Header />
      <Banner />
      <div class="part-2">
        <div class="products-section media-wrapper">
          <div class="product-grid-1">
            <div class="product-item main">
              <img src="@/assets/logo-red.png" alt="" class="logo-img">
              <div class="product-desc">{{ $t('company_intro') }}</div>
            </div>
            <div class="product-item gray">
              <img src="@/assets/images/home/detector.png" alt="" style="object-fit: contain;">
            </div>
            <div class="product-item red bom">
              <!-- <img src="@/assets/images/home/BOM.png" alt=""> -->
              <!-- <img src="@/assets/images/home/商标.png" alt=""> -->
              <div class="product-name" style="letter-spacing: 1px;">BDM</div>
              <div class="product-desc">{{ $t('product_basic_detector_module') }}</div>
            </div>
            <div class="product-item empty"></div>
          </div>
        </div>
        <div class="products-section right-wrapper">
          <div class="product-grid-2">
            <div class="product-item red pni">
              <!-- <img src="@/assets/images/home/PNI.png" alt=""> -->
              <!-- <img src="@/assets/images/home/商标.png" alt=""> -->
              <div class="product-name" style="letter-spacing: 1px;">PNI</div>
              <div class="product-desc">{{ $t('product_plug_n_image') }}</div>
            </div>
            <div class="product-item large">
              <img src="@/assets/images/home/2-3.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="part-3">
        <div class="products-section media-wrapper">
          <div class="part-item">{{ $t('field_oil_exploration') }}</div>
          <div class="part-item">{{ $t('field_nuclear_fusion_detection') }}</div>
          <div class="part-item">{{ $t('field_lightning_detection') }}</div>
        </div>
      </div>
      <div class="part-4">
        <div class="products-section left-wrapper">
          <div class="product-grid-1 flex-start">
            <div class="product-item product-item-img-500">
              <img src="@/assets/images/home/04.png" alt="">
            </div>
            <div class="product-item red">
              <div class="product-desc">{{ $t('honor_wipo_01') }}</div>
              <div class="product-desc">{{ $t('honor_wipo_02') }}</div>
            </div>
            <div class="product-item empty-item"></div>
            <div class="product-item red">
              <div class="product-desc">{{ $t('honor_global_project') }}</div>
              <div class="product-desc">{{ $t('honor_global_project_date') }}</div>
            </div>
          </div>
          <div class="product-grid-2 flex-start">
            <div class="product-item product-item-spacer-750"></div>
            <div class="product-item" style="padding: 0">
              <img src="@/assets/images/home/05.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Banner from '@/components/Banner.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'HomeView',
  components: {
    Header,
    Banner,
    Footer
  }
}
</script>

<style scoped lang="less">
@import '@/assets/styles/views/common.less';

/* 特殊样式保留在组件内部 */
.home-page {
  font-family: HYQiHei_55W, 'Microsoft YaHei', sans-serif;
  user-select: none;
  .header {
    background-color: #89031c;
  }
}

.part-2, .part-4 {
  width: 100%;
  height: 750px;
  background: url(@/assets/images/home/2.png);
  background-size: contain;
  .products-section {
    flex: 1;
    margin: 0 auto;
  }
}
/* .part-3 {
  .products-section {
    flex: 1;
    margin: 0 auto;
  }
} */
.part-2 {
  background-size: cover;
  background-repeat: no-repeat;
  .product-grid-1 {
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
  }
  .right-wrapper {
    padding: 0;
    max-width: unset;
    width: 100%;
    justify-content: flex-end;
  }
  .product-grid-2 {
    display: flex;
    justify-content: flex-end;
  }
}
@media (max-width: 1200px) {
  .part-2 {
    height: 650px;
  }
}
.part-3 {
  width: 100%;
  height: 600px;
  background-color: #fff;
  display: flex;
  align-items: center;
  &>div {
    /* width: 1200px; */
    margin: 0 auto;
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 30px;
    display: flex;
  } 
  
  .part-item {
    flex: auto;
    .info {
      align-items: center;
    }
    &:first-of-type {
      width: 400px;
      height: 400px;
      background-color: #89031c;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &:nth-of-type(2) {
      width: 400px;
      height: 400px;
      background: url(@/assets/images/home/01.png);
      background-size: cover;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
    &:nth-of-type(3) {
      width: 400px;
      height: 400px;
      background: url(@/assets/images/home/02.png);
      background-size: cover;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
  }
}

.part-4 {
  width: 100%;
  height: 750px;
  background: url(@/assets/images/home/3-3.png);
  background-size: cover;
  .left-wrapper {
    margin: 0;
  }
}

.footer {
  width: 100%;
  min-height: 120px;
  background-color: #4d4d4d;
  &>div {
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 20px;
    
    .footer-left, .footer-right {
      display: flex;
      flex-direction: column;
      flex: 1;
      min-width: 250px;
    }
    
    span {
      font-size: 16px;
      color: #fff;
      margin-bottom: 5px;
      transition: transform 0.3s ease, color 0.3s ease;
      cursor: pointer;
    }
    
    .footer-left span {
      text-align: left;
    }
    
    .footer-right span {
      text-align: right;
    }
    
    span:hover {
      transform: scale(1.05);
      color: white;
    }
    
    /* 小屏幕适配 */
    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
      text-align: center;
      
      .footer-left span,
      .footer-right span {
        text-align: center;
      }
    }
  }
}

/* 内联样式转换为class */
.product-item.main {
  width: 500px;
  height: 500px;
  border: 1px solid #89031c;
  padding: 40px 30px;
  
  /* 小屏幕适配 */
  @media (max-width: 1200px) {
    width: 400px;
    height: 400px;
    padding: 30px 20px;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    padding: 20px 15px;
  }
}

.product-item.main .logo-img {
  width: auto;
  height: 40px;
  object-fit: contain;

  @media (max-width: 768px) {
    height: 30px;
  }
}

.product-item.main .product-desc {
  font-size: 16px;
  line-height: 24px;
  font-weight: 100;
  color: #000;
}

.product-item.bom img,
.product-item.pni img {
  width: 50px;
  height: auto;

  /* 小屏幕适配 */
  @media (max-width: 768px) {
    width: 40px;
  }
}

/* 商标图片样式 */
.product-item.bom img[src*="商标"],
.product-item.pni img[src*="商标"] {
  width: auto;
  height: 20px;
  margin-top: 10px;
  object-fit: contain;

  @media (max-width: 768px) {
    height: 16px;
    margin-top: 8px;
  }
}

.product-item.empty {
  width: 250px;
  height: 250px;
  
  /* 小屏幕适配 */
  @media (max-width: 1200px) {
    width: 200px;
    height: 200px;
  }
  
  @media (max-width: 768px) {
    width: 150px;
    height: 150px;
  }
}

.product-item.large {
  width: 500px;
  height: 250px;
  padding: 0;
  
  /* 小屏幕适配 */
  @media (max-width: 1200px) {
    width: 400px;
    height: 200px;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    height: auto;
  }
}

.product-grid-1.flex-start {
  justify-content: flex-start;
  height: 500px;
  
  /* 小屏幕适配 */
  @media (max-width: 1200px) {
    height: auto;
    justify-content: center;
  }
}

.product-grid-2.flex-start {
  height: 250px;
  justify-content: flex-start;

  @media (max-width: 1200px) {
    height: auto;
    justify-content: center;
  }

  @media (max-width: 768px) {
    justify-content: center;
    align-items: center;
    margin-top: 10px;
  }
}

.product-grid-2.flex-start .product-item {
  width: 750px;
  height: 250px;

  /* 小屏幕适配 */
  @media (max-width: 1200px) {
    width: 400px;
    height: 200px;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
  }
}
.product-grid-2.flex-start .product-item:last-of-type {
  width: 250px;
}

.product-grid-1 .product-item-img-500 {
  width: 500px;
  height: 500px;
  padding: 0;

  @media (max-width: 1200px) {
    width: 400px;
    height: 400px;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    max-width: 300px;
  }
}

.product-item-spacer-750 {
  width: 750px;

  @media (max-width: 1200px) {
    width: 400px;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
  }
}

@media (max-width: 768px) {
  .part-2, .part-4 {
    height: auto;
    min-height: 400px;
    background-size: cover;

    .products-section {
      width: 100%;
    }

    .right-wrapper {
      width: 100%;
      max-width: 100%;
      margin-left: 0;
    }

    .left-wrapper {
      width: 100%;
      max-width: 100%;
      margin: 0;
    }

    .product-item {
      max-width: 300px;
      /* max-height: 300px; */
    }

    .product-item.empty,
    .product-item.empty-item,
    .product-item-spacer-750 {
      display: none;
    }
  }

  .part-2 {
    .product-grid-1 {
      flex-wrap: wrap;
      justify-content: center;
      height: auto;
      gap: 10px;
    }
    .product-grid-2 {
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      height: auto;
      margin-top: 10px;
    }
  }

  .part-3 {
    height: auto;
    flex-direction: column;
    padding: 20px 15px;

    > div {
      flex-direction: column;
      width: 100%;
      margin: 0;
    }

    .part-item {
      width: 100%;
      height: auto;
      min-height: 150px;

      &:first-of-type,
      &:nth-of-type(2),
      &:nth-of-type(3) {
        width: 100%;
        height: auto;
        min-height: 150px;
      }
    }
  }

  .part-4 {
    .product-grid-1.flex-start {
      height: auto;
      gap: 10px;
    }
  }
}
</style>